'use strict';
/**
 * Represents the height of form components given all available sizes
 */

var inputHeightDictionary = {
  small: 28,
  standard: 36,
  large: 42
};
exports.inputHeightDictionary = inputHeightDictionary;